module.exports = __webpack_public_path__ + "img/check.5ed2abd1.svg";